import { render } from "./inventoryDays.vue?vue&type=template&id=a25bf52a&scoped=true"
import script from "./inventoryDays.vue?vue&type=script&lang=js"
export * from "./inventoryDays.vue?vue&type=script&lang=js"

import "./inventoryDays.vue?vue&type=style&index=0&id=a25bf52a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a25bf52a"]])

export default __exports__